// assets
import { IconDashboard } from "@tabler/icons";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "dashboard",
  type: "group",
  children: [
    {
      id: "default",
      title: "Dashboard",
      type: "item",
      url: "/dashboard",
      icon: DashboardRoundedIcon,
      color: "#5e35b1", // Deep Purple
      breadcrumbs: false,
    },
  ],
};

export default dashboard;
